/** @jsx jsx */

import { jsx } from '@balance-web/core';
import type { CSSObject } from '@balance-web/core';
import { forwardRefWithAs } from '@balance-web/utils';

import { DialogBase } from './DialogBase';
import type { DialogBaseProps } from './DialogBase';

// NOTE: ideally this wouldn't be necessary. It could be resolved with a
// significant refactor, where the `ContentDialog` accepts `header/body/footer |
// children` and layout is enforced when `body` is present in props.

type BlankDialogProps = DialogBaseProps & {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  autoFocus?: boolean;
  /** Fill the viewport, with the children laid out as a flex column. */
  fullScreen?: boolean;
};

const fullScreenCSS: CSSObject = {
  animation: 'none',
  borderRadius: 0,
  boxShadow: 'none',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  margin: 0,
  maxHeight: '100%',
  overflowY: 'hidden',
  width: '100%',
};

export const BlankDialog = forwardRefWithAs<'div', BlankDialogProps>(
  (
    {
      children,
      autoFocus = false,
      fullScreen,
      dangerouslyInjectedCSS,
      ...props
    },
    ref
  ) => {
    return (
      <DialogBase
        ref={ref}
        autoFocus={autoFocus}
        elevation="modal"
        dangerouslyInjectedCSS={
          fullScreen
            ? { ...fullScreenCSS, ...dangerouslyInjectedCSS }
            : dangerouslyInjectedCSS
        }
        {...props}
      >
        {children}
      </DialogBase>
    );
  }
);
